<template>
  <ui-modal-layout :title="tr('Edit ad details')" :icon="FilePenIcon">
    <info-text type="warning">
      {{ tr('Editing the ad text counts as a significant change, so Meta restarts the learning phase for this ad. While it relearns, performance may fluctuate and costs can temporarily increase until it stabilizes.') }}
    </info-text>

    <div class="flex flex-col gap-1.5">
      <ui-label>{{ tr('Ad text') }}</ui-label>
      <enhanced-textarea
        v-model="text"
        :placeholder="tr('Enter the ad text')"
        :max-consecutive-newlines="2"
        :maxlength="maxTextLength"
      />
    </div>

    <template #footer>
      <ui-button :disabled="isSaving" @click="() => saveChanges()">
        <loader-circle-icon v-if="isSaving" class="animate-spin" />
        {{ tr('Save changes') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { FilePen, LoaderCircle } from '@lucide/vue';
import { markRaw } from 'vue';

import Ad from '@/entities/Ad.js';
import AdService from '@/services/Ad.js';
import EnhancedTextarea from '@/ui/components/EnhancedTextarea.vue';
import InfoText from '@/ui/components/InfoText.vue';

const MAX_AD_TEXT_LENGTH = 16000;

export default {
  name: 'AdDetailsEditModal',
  components: {
    EnhancedTextarea,
    InfoText,
    LoaderCircleIcon: LoaderCircle,
  },
  props: {
    ad: {
      type: Ad,
      required: true,
    },
  },
  data: () => ({
    FilePenIcon: markRaw(FilePen),
    isSaving: false,
    text: '',
    maxTextLength: MAX_AD_TEXT_LENGTH,
  }),
  created() {
    this.text = this.ad.text || '';
  },
  methods: {
    saveChanges() {
      if (this.isSaving) {
        return;
      }

      this.isSaving = true;

      AdService.update(this.ad.id, { text: this.text })
        .then(resp => {
          this.ad.updateWith(resp);

          this.$toast.clear();
          this.$toast.success(this.tr('Ad text changes saved successfully!'));

          this.$emit('close');
          return resp;
        })
        .catch(err => this.error(err))
        .finally(() => this.isSaving = false);
    },
  },
};
</script>
